import React, {useContext} from "react";
import GlobalContext from "../GlobalContext";

const MonthNavigator = () => {

  const CONTEXT = useContext(GlobalContext);

    function createMonthOptions() {
        let options = [];

        for (let c = 0; c < CONTEXT.MONTHS_TRANSLATIONS.length; c++) {
            options.push(<option value={c} key={`mc-${c}`}>{CONTEXT.MONTHS_TRANSLATIONS[c]}</option>);
        }
        return options;
    }

  function setDate(setSelectedYear, y) {
    setSelectedYear(y);
  }

    function handleChangeMonth(event) {
        CONTEXT.setSelectedMonth(event.target.value);
    }

  return (
    <div className="month-navigator ml-2 d-inline-block">
      <GlobalContext.Consumer>
          {({
                setSelectedYear
            }) => (
              <select className=""
                      onChange={handleChangeMonth}
                      value={CONTEXT.selectedMonth}
              >
                  {createMonthOptions()}
              </select>
          )}
      </GlobalContext.Consumer>
    </div>
  );
};

export default MonthNavigator;
